import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { AmountType, GrowProject } from '@inyova/grow';
import { AmplitudeService } from '@inyova/inyova-shared';

enum AgreementTypes {
  DOCUMENTS = 'documents',
  GENERAL = 'general',
  WAIVER = 'waiver'
}

@Component({
  selector: 'app-inyova-grow-investment-consent',
  templateUrl: './inyova-grow-investment-consent.component.html',
  styleUrls: ['./inyova-grow-investment-consent.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class InyovaGrowInvestmentConsentComponent implements OnInit {
  @Input() loading: boolean;
  @Input() selectedAmount: number;
  @Input() selectedType: AmountType;
  @Input() project: GrowProject;
  @Output() submitInvestment: EventEmitter<{ valid: boolean }> = new EventEmitter<{ valid: boolean }>();

  agreementTypes = AgreementTypes;
  agreements: { [key: string]: boolean };
  submitted = false;
  hasDocuments = false;

  constructor(private amplitudeService: AmplitudeService) {}

  ngOnInit() {
    this.agreements = {
      [AgreementTypes.DOCUMENTS]: false,
      [AgreementTypes.GENERAL]: false,
      [AgreementTypes.WAIVER]: false
    };
    this.hasDocuments = typeof this.project.investment_documents !== 'undefined' || this.project.investment_documents !== null;
    this.amplitudeService.trackEvent('Grow Investment Flow Started', {
      investment_flow_step: 'step_2',
      investment_amount_type: this.selectedType === AmountType.RECOMMENDED ? 'suggested_amount_chosen' : 'manual_amount_entered'
    });
  }

  openDocPDF(url: string, title: string) {
    this.amplitudeService.trackEvent('Grow Investment Documents Opened', { investment_flow_step: 'step_2', doc_name: title });
    void Browser.open({
      url
    });
  }

  onAccept(type: AgreementTypes) {
    this.agreements[type] = !this.agreements[type];
  }

  onSubmit() {
    this.submitted = true;
    const valid = !Object.values(this.agreements).some((value) => value === false);
    this.submitInvestment.emit({ valid });
  }
}
